import { AddBulkProducts } from '../../pages';
import { InventoryController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const AddBulkProductsContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();

	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	const uploadClick = async payload => {

		const formData = new FormData();
		setLoading(true);
		let fileToSend;

		if (typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
		}
		formData.append('products', fileToSend);
		const { status, errorMessage } =
			await InventoryController.createBulkProducts(formData);
		if (status === constant.Success) {
			setUploaded(true);
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		setLoading(false);
	};
	
	return (
		<AddBulkProducts
			closeModal={closeModal}
			uploaded={uploaded}
			uploadClick={uploadClick}
			file={file}
			selectClick={selectClick}
			loading={loading}
		/>
	);
};

export default observer(AddBulkProductsContainer);
